import React, { useMemo } from "react";
import { Bar } from "react-chartjs-2";
import { IWorkItemDetails } from "../../interfaces/IWorkItemDetails";
import { ALL } from "./ReleaseComparison";

const options = {
  responsive: true,
  maintainAspectRatio: false,
  animation: { duration: 0 },
  indexAxis: 'y',
  scales: {
    x: {
      stacked: true,
      beginAtZero: true,
      grid: {
        display: false,
      },
      ticks: {
        display: false,
      },
      border: {
        display: false,
      },
    },
    y: {
      stacked: true,
      grid: {
        display: false,
      },
      ticks: {
        display: false,
      },
      border: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: true,
    },
  },
};

interface IReworkBarChart {
  reworkItems: IWorkItemDetails[]
  selectedType: string
}

const ReworkBarChart: React.FC<IReworkBarChart> = ({ reworkItems, selectedType }) => {

  const filterData = ((item: IWorkItemDetails[]) => {
    if (selectedType === ALL) return item
    const data = item.filter((i) => i.work_item_type === selectedType).sort((a, b) => a.id - b.id);
    return data
  })


  const datasets = useMemo(() => {
    const data = filterData(reworkItems)
    const finalData = data.filter((item) => { return item?.state_category !== null }).sort()?.reduce((acc: any, item) => {
      const value = parseFloat(item.value);
      acc[item.state_category] = (acc[item.state_category] || 0) + value;
      return acc;

    }, []);

    const colors: string[] = [
      'rgba(3, 4, 94, 1)',
      'rgba(2, 62, 138, 1)',
      'rgba(0, 119, 182, 1)',
      'rgba(0, 150, 199, 1)',
      'rgba(0, 180, 216, 1)',
      'rgba(72, 202, 228, 1)',
      'rgba(144, 224, 239, 1)',
      'rgba(173, 232, 244, 1)',
      'rgba(202, 240, 248, 1)'
    ]
    
    return Object.entries(finalData).map(([label, value],index) => {
      return {
        label: label,
        data: [value],
        backgroundColor: colors[index]
      }
    },

    );
  }, [reworkItems, selectedType]);

  const data = {
    labels: [''],
    datasets: datasets,
  };

  return (
    <div className="h-[60px]">
      <Bar data={data} options={options as any} />
    </div>
  );
};

export default ReworkBarChart;
